module.exports = __webpack_public_path__ + "static/media/community.b3d21442.svg";